import { useEffect, useState } from "react";
import { api, mediaUrl } from "../lib/api";
import { PageHero, Loader, CTASection } from "../components/ui-bits";
import { Reveal } from "../components/Reveal";
import { MediaImage } from "../components/MediaImage";

const ABOUT_BG = "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function About() {
  const [site, setSite] = useState(null);
  const [leaders, setLeaders] = useState([]);

  useEffect(() => {
    api.get("/settings/site").then((r) => setSite(r.data)).catch(() => setSite(false));
    api.get("/leaders").then((r) => setLeaders(r.data)).catch(() => {});
  }, []);

  if (site === null) return <Loader label="Loading" />;

  const about = site?.about || { title: "About Us", body: [] };

  return (
    <div data-testid="about-page">
      <PageHero
        eyebrow="Who We Are"
        title="A global conglomerate built for a fast-changing world."
        subtitle="Emerald-grade ambition across eleven interconnected verticals, backed by international partnerships and senior specialists."
        bg={ABOUT_BG}
      />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <Reveal>
          <div className="prose-emerald max-w-none">
            {(about.body && about.body.length ? about.body : [
              "SRAM & MRAM Group is a global conglomerate delivering futuristic technology solutions across multiple industries.",
              "We identify innovative business verticals, invest in futuristic technologies, create opportunities and empower talent to achieve and sustain market-leading positions.",
            ]).map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </Reveal>
      </section>

      {/* Leadership */}
      {leaders.length > 0 && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <p className="eyebrow mb-3">Leadership</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-display font-bold text-white mb-10 tracking-tight">Senior Management &amp; Key Personnel</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {leaders.map((l, i) => (
              <Reveal key={l.id} delay={(i % 3) * 0.06}>
                <div className="card-vertical rounded-2xl overflow-hidden h-full" data-testid={`leader-card-${l.slug}`}>
                  <div className="h-56 overflow-hidden bg-slate-900">
                    <MediaImage src={l.image_url} alt={l.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="p-6">
                    <h3 className="font-display font-semibold text-white text-lg">{l.name}</h3>
                    {l.bio && l.bio[0] && <p className="text-sm text-slate-400 mt-2 line-clamp-3">{l.bio[0]}</p>}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </section>
      )}

      <CTASection />
    </div>
  );
}
